export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
